var _defs, _path, _path2, _path3, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitsLine0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.21 257.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}.cls-2{fill:#1d1d1b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illu_Linie_0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,254.56C-9.19,31,284.92,180.77,278.06,3.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.68,132c-14,5.1-27.93,11.09-39.43,20.78a75,75,0,0,0-8.41,8.31,2.57,2.57,0,0,0,0,3.54,2.54,2.54,0,0,0,3.54,0c9.09-10.52,20.9-17.63,33.56-23.08,4-1.71,8-3.25,12.07-4.72a2.58,2.58,0,0,0,1.75-3.08A2.53,2.53,0,0,0,87.68,132Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.71,77.08C242,72.16,250,66.41,255,57.92c1.63-2.78-2.69-5.3-4.32-2.52-4.51,7.69-11.83,12.85-19.48,17.36-2.77,1.63-.25,6,2.53,4.32Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.01,
    cy: 169.6,
    r: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.69,
    cy: 176.1,
    r: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.64,
    cy: 48.54,
    r: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsLine0);
export default __webpack_public_path__ + "static/media/benefits_line_0.5deee09673b9a4939fbcadafbf0f650d.svg";
export { ForwardRef as ReactComponent };